import React, { Component } from "react";
import "./Popup.scss";
import Select from "../../components/Select";
import Textarea from "../../components/Textarea";
import Button from "../../components/Button";
import Row from "../../components/Row";
import Col from "../../components/Col";

const Reasons = [
  {
    label: "Not covered under warranty",
    value: "Not covered under warranty",
  },
  {
    label: "Homeowner / occupant caused",
    value: "Homeowner / occupant caused",
  },
  {
    label: "Working as expected",
    value: "Working as expected",
  },
  {
    label: "1 Year Warranty item",
    value: "1 Year Warranty item",
  },
  {
    label: "Duplicate",
    value: "Duplicate",
  },
  {
    label: "Other",
    value: "Other",
  },
];
// Modified by: Tarkeshwar Prasad Yadav
// Modified on: 27/10/2022
// Jira ticket: JUN-3376
// Comment: Declined option updated for Albaster.
const albasterReasons = [
  {
    label: "Not covered under warranty",
    value: "Not covered under warranty",
  },
  {
    label: "Common property item",
    value: "Common property item",
  },
  {
    label: "Damage reported after occupancy",
    value: "Damage reported after occupancy",
  },
  {
    label: "Functioning as intended",
    value: "Functioning as intended",
  },
  {
    label: "Warranty coverage expired",
    value: "Warranty coverage expired",
  },
  {
    label: "Other",
    value: "Other",
  },
];
class Popup extends Component {
  state = {
    reason: "",
    description: "",
  };
  onClickButton = (type) => {
    if (type === "cancel") {
      this.props.onSubmitPopup(type);
    } else {
      let params = {
        reason: this.state.reason,
        description: this.state.description,
      };
      this.props.onSubmitPopup(type, params);
    }
  };
  render() {
    const theme = localStorage.getItem("theme");
    return (
      <div className="app">
        <div className="popup">
          <Select
            value={this.state.reason}
            onChange={(e) => this.setState({ reason: e.target.value })}
            options={theme === "Albaster" ? albasterReasons : Reasons}
            label="Reasons"
            placeholder="(Select Reason)"
            block
          />
          <Textarea
            required
            value={this.state.description}
            onChange={(e) => this.setState({ description: e.target.value })}
            label="Description"
            placeholder="Description"
            block
          />
          <Row>
            <Col xs="12" md="2">
              <Button
                color="complete_purple"
                size="small"
                label="Cancel"
                onClick={() => this.onClickButton("cancel")}
              />
            </Col>
            <Col xs="12" md="2">
              <Button
                color="teal"
                size="small"
                label="Submit"
                onClick={() => this.onClickButton("submit")}
                disabled={!this.state.reason || !this.state.description}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Popup;
